<template>
  <div>
    <div class="row">
      <div class="col-md-12 ml-auto mr-auto">
        <card type="plain" class="card-subcategories">
          <!-- <template slot="header">
                    <h4 class="card-title text-center">Page Subcategories</h4>
                    <br>
          </template>-->
          <tabs pills type="primary" icons centered tab-content-classes="tab-space">
            <!-- <tab-pane id="home" key="home">
              <span slot="title">
                <i class="nc-icon nc-umbrella-13"></i> User Details
              </span>
              Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits.
              <br />
              <br />
Dramatically visualize customer directed convergence without revolutionary ROI.
            </tab-pane>-->
            <tab-pane id="messages" key="messages">
              <span slot="title">
                <i class="nc-icon nc-shop"></i> Assigned Sites and Roles
              </span>
              <div class="row">
                <div class="col-md-8">
                  <h3>Assigned Sites and Roles</h3>
                </div>
                <div class="col-md-4">
                  <p-button
                    class="btn btn-success pull-right"
                    @click="openAssignSiteModal"
                    v-if="hasAssignSiteandRolePermission"
                  >
                    <i class="fas fa-user-shield"></i> Assign Site & Role
                  </p-button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 card">
                  <div class="card-body row">
                    <div class="col-2">
                      <el-select
                        class="select-default"
                        v-model="pagination.perPage"
                        placeholder="Per page"
                        size="mini"
                      >
                        <el-option
                          class="select-default"
                          v-for="item in pagination.perPageOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="col-sm-12 mt-2">
                      <el-table class="table-striped" :data="tableData" border style="width: 100%">
                        <el-table-column
                          v-for="column in tableColumns"
                          align="center"
                          :key="column.label"
                          :min-width="column.minWidth"
                          :prop="column.prop"
                          :label="column.label"
                        ></el-table-column>
                        <el-table-column
                          :min-width="50"
                          fixed="right"
                          align="center"
                          class-name="td-actions"
                          label="Actions"
                        >
                          <template slot-scope="props">
                            <p-button
                              type="warning"
                              size="sm"
                              icon
                              @click="handleEdit(props.$index, props.row)"
                              v-if="hasEditSiteRolePermission(props.row)"
                            >
                              <i class="fa fa-edit"></i>
                            </p-button>
                            <p-button
                              type="danger"
                              size="sm"
                              icon
                              @click="handleDelete(props.$index, props.row)"
                              v-if="hasDeleteSiteRolePermission(props.row)"
                            >
                              <i class="fa fa-trash-alt"></i>
                            </p-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="col-sm-6 pagination-info">
                      <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <div class="col-sm-6">
                      <p-pagination
                        class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total"
                        @input="inputChanged($event)"
                      ></p-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>
            <tab-pane id="settings" key="settings">
              <span slot="title">
                <i class="nc-icon nc-settings"></i> Additional Permission
              </span>
              <additional-permisssion-list />
            </tab-pane>
          </tabs>
        </card>
      </div>
    </div>
    <!-- assign new site and role modal -->
    <modal :show.sync="assignSiteModal" footer-classes="justify-content-center" type="notice">
      <h5 slot="header" class="text-primary modal-title">Assign Site & Role</h5>
      <template>
        <form>
          <div class="form-group">
            <label for="siteDropdown">Sites</label>
            <v-select
              multiple
              name="siteDropdown"
              label="name"
              :options="siteOptions"
              v-model="selectedSites"
            ></v-select>
          </div>
          <div class="form-group">
            <div class="form-group" v-for="role in roles" v-bind:key="role.id">
              <p-radio v-model="pickedRole" :label="role.id">{{role.role_name}}</p-radio>
            </div>
          </div>
        </form>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="assignSiteModal = false">Close</p-button>
        <p-button type="success" @click.native="insertSiteUserRoleAPI">Add</p-button>
      </template>
    </modal>

    <!-- edit new role modal -->
    <modal :show.sync="editSiteRoleModal" footer-classes="justify-content-center" type="notice">
      <h5 slot="header" class="text-primary modal-title">Edit Role</h5>
      <template>
        <form>
          <div class="form-group">
            <fg-input label="Site" name="site" :disabled="true" v-model="editRoleModel.siteName"></fg-input>
          </div>
          <div class="form-group">
            <div class="form-group" v-for="role in roles" v-bind:key="role.id">
              <p-radio v-model="pickedRole" :label="role.id">{{role.role_name}}</p-radio>
            </div>
          </div>
        </form>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="editSiteRoleModal = false">Close</p-button>
        <p-button type="success" @click.native="editSiteRole">Save</p-button>
      </template>
    </modal>
  </div>
</template>

<script>
import StatsCard from "src/components/UIComponents/Cards/StatsCard";
import swal from "sweetalert2";
import HTTP from "src/util/http-common.js";
import Modal from "src/components/UIComponents/Modal.vue";
// import PPagination from 'src/components/UIComponents/Pagination.vue'
// import {Table, TableColumn, Select, Option} from 'element-ui'

import {
  Collapse,
  CollapseItem,
  Tabs,
  TabPane,
  Card
} from "src/components/UIComponents";

import AdditionalPermissionList from "src/components/Dashboard/Views/UserManagement/AdditionalPermissionList.vue";

export default {
  components: {
    StatsCard,
    Modal,
    // PPagination,
    TabPane,
    Tabs,
    CollapseItem,
    Collapse,
    Card,
    "additional-permisssion-list": AdditionalPermissionList
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0
      },
      userDetails: {},
      siteOptions: [],
      selectedSites: [],
      assignSiteModal: false,
      roles: [],
      pickedRole: null,
      tableData: [],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50
        },
        {
          prop: "siteName",
          label: "Site",
          minWidth: 120
        },
        {
          prop: "roleName",
          label: "Role",
          minWidth: 70
        }
      ],
      siteNameToEdit: null,
      editRoleModel: {},
      editSiteRoleModal: false,
      generalPermissions: this.$store.getters["auth/generalPermissions"],
      sitePermissions: this.$store.getters["auth/sitePermissions"]
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    hasAssignSiteandRolePermission() {
      if (this.generalPermissions.includes("site_user_role.put")) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    assignSiteModal: function(newVal, oldVal) {
      if (newVal == false) {
        this.pickedRole = null;
        this.selectedSites = [];
      }
    },
    editSiteRoleModal: function(newVal, oldVal) {
      if (newVal == false) {
        this.pickedRole = null;
        this.editRoleModel = {};
        this.roles = [];
      }
    },
    "pagination.perPage": function(newVal, oldVal) {
      console.log("per page changed from ", oldVal, "to ", newVal);
      this.pagination.currentPage = 1;
      this.setSiteRoleList();
    }
  },
  created() {
    this.setUsers();
    this.setSiteRoleList();
    // console.log(this.hasEditSiteRolePermission({site_id: 1}))
  },
  methods: {
    async fetchUser() {
      let params = {
        user_id: this.$route.params.userId
      };

      const response = await HTTP.get("api/v1/site_user_role/", {
        params: params
      });
      const data = await response.data;
      return data;
    },
    setUsers() {
      let loader = this.$loading.show();
      this.fetchUser()
        .then(data => {
          loader.hide();
          this.userDetails = data;
        })
        .catch(err => {
          loader.hide();
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              this.$notify({
                group: "general",
                title: "Bad Request",
                text: err.response.data.message,
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              this.$notify({
                group: "general",
                title: "Internal Server Error. Please try again later..",
                text: err.response.data.message,
                type: "error"
              });
            } else {
              this.$notify({
                group: "general",
                title: "Bad Request",
                text: error,
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            this.$notify({
              group: "general",
              title: "Server Error",
              text: err.request,
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$notify({
              group: "general",
              title: "Error",
              text: err.message,
              type: "error"
            });
          }
        });
    },
    async fetchSites() {
      const response = await HTTP.get(
        "api/v1/site_user_role/managed-sites/available",
        {
          params: {
            user_id: this.$route.params.userId
          }
        }
      );
      const data = await response.data;
      return data;
    },
    setSites() {
      let loader = this.$loading.show();
      this.fetchSites()
        .then(data => {
          this.siteOptions = data;
          loader.hide();
        })
        .catch(err => {
          console.log(err);
          loader.hide();
        });
    },
    openAssignSiteModal() {
      this.assignSiteModal = true;
      this.setSites();
      this.setRoles();
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async fetchRoles() {
      const response = await HTTP.get("api/v1/role/list", {});
      const data = await response.data;
      return data;
    },
    setRoles() {
      this.fetchRoles()
        .then(data => {
          this.roles = data;
        })
        .catch(err => {
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              this.$notify({
                group: "general",
                title: "Bad Request",
                text: err.response.data.message,
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              this.$notify({
                group: "general",
                title: "Internal Server Error. Please try again later..",
                text: err.response.data.message,
                type: "error"
              });
            } else {
              this.$notify({
                group: "general",
                title: "Bad Request",
                text: error,
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            this.$notify({
              group: "general",
              title: "Server Error",
              text: err.request,
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$notify({
              group: "general",
              title: "Error",
              text: err.message,
              type: "error"
            });
          }
        });
    },
    insertSiteUserRoleAPI() {
      var site_ids = [];

      for (let row of this.selectedSites) {
        site_ids.push(row.id);
      }
      var params = {
        site_id_list: site_ids,
        role_id: this.pickedRole,
        user_id: this.$route.params.userId
      };
      HTTP.put("api/v1/site_user_role/list", params)
        .then(response => {
          this.assignSiteModal = false;
          swal({
            title: "Successfully assigned Sites and Role",
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success"
          });
          this.$store.dispatch("auth/retrieveUserPermissions");
        })
        .catch(err => {
          if (err.response) {
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              swal({
                title: "Bad Request",
                text: err.response.data.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            } else {
              swal({
                title: "Bad Request",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: err.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: err.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          }
        });
    },
    async fetchSiteRoleList() {
      let params = {
        user_id: this.$route.params.userId,
        page: this.pagination.currentPage,
        page_size: this.pagination.perPage
      };

      const response = await HTTP.get("api/v1/site_user_role/list", {
        params: params
      });
      const data = await response.data;
      return data;
    },
    setSiteRoleList() {
      this.tableData = [];
      this.fetchSiteRoleList()
        .then(data => {
          this.pagination.total = data.total;
          for (let row of data.results) {
            this.tableData.push({
              roleName: row.role.role_name,
              siteName: row.site.name,
              id: row.id,
              role_id: row.role.id,
              site_id: row.site.id
            });
          }
        })
        .catch(err => {
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              this.$notify({
                group: "general",
                title: "Bad Request",
                text: err.response.data.message,
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              this.$notify({
                group: "general",
                title: "Internal Server Error. Please try again later..",
                text: err.response.data.message,
                type: "error"
              });
            } else {
              this.$notify({
                group: "general",
                title: "Bad Request",
                text: error,
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            this.$notify({
              group: "general",
              title: "Server Error",
              text: err.request,
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$notify({
              group: "general",
              title: "Error",
              text: err.message,
              type: "error"
            });
          }
        });
    },
    handleEdit(index, row) {
      this.editSiteRoleModal = true;
      this.setRoles();
      this.editRoleModel = row;
      this.pickedRole = row.role_id;
    },
    editSiteRole() {
      var params = {
        site_id: this.editRoleModel.site_id,
        role_id: this.pickedRole,
        user_id: this.$route.params.userId
      };
      HTTP.put("api/v1/site_user_role/", params)
        .then(response => {
          this.editSiteRoleModal = false;
          swal({
            title: "Successfully assigned Sites and Role",
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success"
          });
          this.setSiteRoleList();
          this.$store.dispatch("auth/retrieveUserPermissions");
        })
        .catch(err => {
          this.editSiteRoleModal = false;
          if (err.response) {
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              swal({
                title: "Bad Request",
                text: err.response.data.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            } else {
              swal({
                title: "Bad Request",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: err.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: err.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          }
        });
    },
    handleDelete(index, row) {
      this.deleteSiteUserRoleAPI(row);
    },
    deleteSiteUserRoleAPI(row) {
      var params = {
        site_id: row.site_id,
        role_id: row.role_id,
        user_id: this.$route.params.userId
      };
      HTTP.delete("api/v1/site_user_role/", { data: params })
        .then(response => {
          swal({
            title: "Successfully Deleted Sites and Role",
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success"
          });
          this.setSiteRoleList();
          this.$store.dispatch("auth/retrieveUserPermissions");
        })
        .catch(err => {
          if (err.response) {
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              swal({
                title: "Bad Request",
                text: err.response.data.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            } else {
              swal({
                title: "Bad Request",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: err.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: err.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          }
        });
    },
    inputChanged(pageNum) {
      console.log("page changed", pageNum);
      this.setSiteRoleList();
    },
    hasEditSiteRolePermission(row) {
      var strId = row.site_id.toString();
      if (this.generalPermissions.includes("site_user_role.put")) {
        return true;
      } else {
        return false;
      }
    },
    hasDeleteSiteRolePermission(row) {
      var strId = row.site_id.toString();
      if (this.generalPermissions.includes("site_user_role.delete")) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
